//import WriteDiscoverMapPopup from "@/pages/comp/edu/discover_map/popup/write";
import { useState, useRef, useEffect } from 'react';
import DisCoverMapWriteArea from "@/pages/comp/edu/discover_map/common/write";

function WriteDiscoverMapPopup(props: any) {
  let myProps = {
    stu_seq:"",
    row_data: {},
    is_update:false,
    list: (inData: any) => { },
    closePopup: () => { },
    ...props
  };
  const DisCoverMapWriteAreaRef = useRef<any>(null);

  useEffect(() => {
    if (DisCoverMapWriteAreaRef.current) {
      DisCoverMapWriteAreaRef.current.initData({
        stu_seq:myProps.stu_seq,
        info:myProps.row_data,
        info_arr:[myProps.row_data],
        is_view_mode:false,
        list_opt:{},
      });
    }
  }, []);

  return (
    <div>
      <DisCoverMapWriteArea
          ref={DisCoverMapWriteAreaRef}
          list={(inData: any) => {
            myProps.list({});
          }}
        ></DisCoverMapWriteArea>
    </div>
  );
};
export default WriteDiscoverMapPopup;